
import { VerificationLayout } from "@/components/seller/verification/VerificationLayout";
import { CookQuiz } from "@/components/seller/verification/CookQuiz";
import { useNavigate } from "react-router-dom";

const CookQuizPage = () => {
  const navigate = useNavigate();

  return (
    <VerificationLayout currentStep={3} totalSteps={3}>
      <div className="space-y-6">
        <div>
          <h2 className="text-2xl font-semibold tracking-tight text-primary">Food Safety Quiz</h2>
          <p className="text-foreground">
            Complete this quiz to demonstrate your understanding of food safety practices.
          </p>
        </div>

        <CookQuiz onComplete={() => navigate("/seller/verification/complete")} />
      </div>
    </VerificationLayout>
  );
};

export default CookQuizPage;
